import { render, staticRenderFns } from "./EmphasisMarkDialog.vue?vue&type=template&id=1d8e8eac&scoped=true"
import script from "./EmphasisMarkDialog.vue?vue&type=script&lang=ts"
export * from "./EmphasisMarkDialog.vue?vue&type=script&lang=ts"
import style0 from "./EmphasisMarkDialog.vue?vue&type=style&index=0&id=1d8e8eac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8e8eac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d8e8eac')) {
      api.createRecord('1d8e8eac', component.options)
    } else {
      api.reload('1d8e8eac', component.options)
    }
    module.hot.accept("./EmphasisMarkDialog.vue?vue&type=template&id=1d8e8eac&scoped=true", function () {
      api.rerender('1d8e8eac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/EmphasisMarkDialog.vue"
export default component.exports